import React from 'react'

const Footer = () => {
  return (
    <footer>
      <hr />
      <div className="right">
        COPYRIGHT ⓒ 2022 강혜리. ALL RIGHTS RESERVED.<br />
        본 사이트는 개인 포트폴리오 사이트로 제작되어 상업적 목적이 아닙니다.<br />
        사용된 일부 이미지 및 폰트 등은 별도의 출처가 있음을 밝혀 드립니다.
      </div>
    </footer>
  )
}

export default Footer
